import React from 'react'
import { connect } from 'react-redux'
import {
  getCurrentLanguage,
  getLanguageTabsSelector,
  languageStateSelector,
  setLangAction,
  setLangTabsAction,
} from './duck'
import {
  getItemDetailSelector,
  getPassageSelector,
} from '../../../author/ItemDetail/ducks'
import { allowedToSelectMultiLanguageInTest } from '../../../author/src/selectors/user'
import { clearAnswersAction } from '../../../author/src/actions/answers'
import useQuestionLanguageTab from './hooks/useQuestionLanguageTab'
import BaseLanguageSelectorTab from './BaseLanguageSelectorTab'

const QuestionLanguageSelectorTab = ({
  item,
  isLCB = false,
  currentLang,
  isEditView,
  isBeta,
  setLanguage,
  passage,
  allowedToSelectMultiLanguage,
  setLanguageTabs,
  languageTabs,
  currentItemId,
  authoredQuestions,
  isItemDetailView,
  isQuestionEditView,
  clearAnswers,
}) => {
  const {
    popoverVisible,
    setPopoverVisible,
    selectedLanguages,
    showAddLanguageButton,
    languageTabsToShow,
    handleChangeLanguage,
    handleSaveLanguage,
    handleSelectedLang,
  } = useQuestionLanguageTab({
    item,
    isLCB,
    currentLang,
    isEditView,
    isBeta,
    setLanguage,
    passage,
    allowedToSelectMultiLanguage,
    setLanguageTabs,
    languageTabs,
    currentItemId,
    authoredQuestions,
    isItemDetailView,
    isQuestionEditView,
    clearAnswers,
  })

  const isFullWidth = item.isPassageWithQuestions || item.multipartItem || isLCB
  const isOffset = isEditView

  return (
    <BaseLanguageSelectorTab
      handleSelectedLang={handleSelectedLang}
      selectedLanguages={selectedLanguages}
      handleSaveLanguage={handleSaveLanguage}
      isFullWidth={isFullWidth}
      isOffset={isOffset}
      isBeta={isBeta}
      popoverVisible={popoverVisible}
      setPopoverVisible={setPopoverVisible}
      handleChangeLanguage={handleChangeLanguage}
      currentLang={currentLang}
      languageTabsToShow={languageTabsToShow}
      showAddLanguageButton={showAddLanguageButton}
    />
  )
}

export default connect(
  (state) => ({
    initialLang: languageStateSelector(state),
    currentLang: getCurrentLanguage(state),
    languageTabs: getLanguageTabsSelector(state),
    item: getItemDetailSelector(state),
    passage: getPassageSelector(state),
    allowedToSelectMultiLanguage: allowedToSelectMultiLanguageInTest(state),
    currentItemId: state.authorQuestions.current,
    authoredQuestions: state.authorQuestions.byId,
  }),
  {
    setLanguage: setLangAction,
    setLanguageTabs: setLangTabsAction,
    clearAnswers: clearAnswersAction,
  }
)(QuestionLanguageSelectorTab)
